export default async function sendPointOfNeedAppEvent(almeApiUtils, almeState, ponEnterpriseId) {
    const launchParams = {
        LaunchPointName: almeState.launchPointName || "",
        LaunchParameter: almeState.launchParameter || "",
        LaunchType: 'Reactive',
    };
    if (launchParams.LaunchParameter === "PointOfNeed") {
        const params = ponEnterpriseId ? Object.assign(Object.assign({}, launchParams), { ponEnterpriseId }) : launchParams;
        return almeApiUtils.sendAppEvent('PointOfNeed', undefined, params);
    }
    return null;
}
